import { Component, OnInit, OnDestroy, Output, EventEmitter, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-shipping-settings',
  templateUrl: './shipping-settings.component.html',
  styleUrls: ['./shipping-settings.component.scss']
})
export class ShippingSettingsComponent implements OnInit, OnDestroy {
  @Input() shippingForm: FormGroup | null = null;
  @Output() formSubmitted = new EventEmitter<any>();
  @Output() toggleShipping = new EventEmitter<boolean>();

  private destroy$ = new Subject<void>();
  rateTypes: any[] = [
    { label: 'Flat Rate', value: 'flat' },
    { label: 'Per Item', value: 'peritem' },
    { label: 'Weight Based', value: 'weightbased' }
  ];

  constructor(private _formBuilder: FormBuilder) {}

  ngOnInit(): void {
    if (!this.shippingForm) {
      this.initializeForm();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private initializeForm(): void {
    this.shippingForm = this._formBuilder.group({
      shippingEnabled: [false],
      rateType: ['flat'],
      shippingCost: [0, [Validators.min(0)]]
    });
  }

  onToggleShipping(): void {
    const isEnabled = this.shippingForm?.get('shippingEnabled')?.value || false;
    this.toggleShipping.emit(isEnabled);
  }

  onSubmit(): void {
    if (this.shippingForm && this.shippingForm.valid) {
      this.formSubmitted.emit(this.shippingForm.value);
    }
  }

  resetForm(): void {
    if (this.shippingForm) {
      this.shippingForm.reset({
        shippingEnabled: false,
        rateType: 'flat',
        shippingCost: 0
      });
    }
  }

  get shippingEnabled(): boolean {
    return this.shippingForm?.get('shippingEnabled')?.value || false;
  }

  set shippingEnabled(value: boolean) {
    this.shippingForm?.patchValue({ shippingEnabled: value }, { emitEvent: false });
  }

  get rateType(): string {
    return this.shippingForm?.get('rateType')?.value || 'flat';
  }

  get shippingCost(): number {
    return this.shippingForm?.get('shippingCost')?.value || 0;
  }
}
